import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ChangePasswordFormValues } from '../schemas/change-password.schema';
import { changePassword, updateProfile } from './auth.api';
import { currentUserKeys } from './current-user.queries';

/** Changes your own password, then refreshes /admin/me (clears a forced change). */
export function useChangePassword() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values: ChangePasswordFormValues) =>
      changePassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: currentUserKeys.me }),
  });
}

/** Changes your own display name, then refreshes /admin/me so the new name shows. */
export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => updateProfile(name),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: currentUserKeys.me }),
  });
}
